import React, { FC } from 'react';
import { useNavigate } from 'react-router';

const EditCustomerButton: FC = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/edit-customer');
  };

  return (
    <span className="buttons">
      <button type="button" className="btn btn-primary" onClick={handleClick}>
        Edit Customer
      </button>
    </span>
  );
};

export default EditCustomerButton;
